export default "__VITE_ASSET__BSXh2KO3__"